import React from "react";
import { Bar } from "react-chartjs-2";

const SatelliteLaunchesChart = ({ data }) => {
  const yearLaunches = data.reduce((acc, country) => {
    if (country.satellites_list) {
      country.satellites_list.forEach((launch) => {
        const launchYear = new Date(launch.launch_date).getFullYear();
        acc[launchYear] = (acc[launchYear] || 0) + 1;
      });
    }
    return acc;
  }, {});

  const chartData = {
    labels: Object.keys(yearLaunches),
    datasets: [
      {
        label: "Number of launches",
        data: Object.values(yearLaunches),
        borderColor: "#D64045",
        backgroundColor: "#D7DFF2",
        borderWidth: 1,
      },
    ],
  };

  return (
    <div className="font-bold w-full h-full flex flex-col items-center justify-center p-[5px]">
      <h3>Satellites launches per year</h3>
      <Bar
        data={chartData}
        options={{
          responsive: true,
          maintainAspectRatio: true,
          plugins: {
            legend: {
              display: false,
            },
          },
        }}
      />
    </div>
  );
};

export default SatelliteLaunchesChart;
